<template>
  <div class="join-us" :class="{'join-us-vs':isMobile,'english':lang=='EN'}" style="background:#fafafa">
    <myheader :title="$t('joinUs.hd')" v-on:changeOffers="getOffers" :menu="['offers1','offers2','offers3']" :tabindex="indexTab"></myheader>
    <div class="selectBox">
      <div class="selectBoxLeft">
          <div>
               <div>{{$t('joinUs.selectJob.kind1.name')}}</div>
               <div><span v-for="(item,index) in $t('joinUs.selectJob.kind1.value')" :key="index" :class="{'active':index==selectOne}" @click="changeCity(index)">{{item}}</span></div>
          </div>
          <!-- 社招 -->
          <div v-show="indexTab==0">
               <div>{{$t('joinUs.selectJob.kind2.name')}}</div>
               <div><span v-for="(item,index) in $t('joinUs.selectJob.kind2.value')" :key="index" :class="{'active':index==selectTwo}" @click="changeKind(index)">{{item}}</span></div>
          </div>
          <!-- 校招 -->
          <div v-show="indexTab==1">
               <div>{{$t('joinUs.selectJob.kind4.name')}}</div>
               <div><span v-for="(item,index) in $t('joinUs.selectJob.kind4.value')" :key="index" :class="{'active':item.value==selectTwo}" @click="changeKind(item.value)">{{item.name}}</span></div>
          </div>
          <!-- 实习 -->
          <div v-show="indexTab==2">
               <div>{{$t('joinUs.selectJob.kind5.name')}}</div>
               <div><span v-for="(item,index) in $t('joinUs.selectJob.kind5.value')" :key="index" :class="{'active':item.value==selectTwo}" @click="changeKind(item.value)">{{item.name}}</span></div>
          </div>
          <div>
               <div>{{$t('joinUs.selectJob.kind3.name')}}</div>
               <div><span v-for="(item,index) in $t('joinUs.selectJob.kind3.value')" :key="index" style="cursor: initial;">{{item}}</span></div>
          </div>
      </div>
<!--      <div class="selectBoxRight" v-if="!isMobile">-->
<!--        <img src="../assets/img/joinUs/joinUsHr.png" style="width:6.25rem;height:6.25rem;pointer-events:auto;" />-->
<!--        <div>{{$t('joinUs.tip5')}}</div>-->
<!--      </div>-->
    </div>
    <div class="job-offer">
        <ul>
            <li>{{$t('joinUs.post')}}</li>
            <li>{{$t('joinUs.site')}}</li>
            <li>{{$t('joinUs.apply')}}</li>
        </ul>
        <div class="table-ui">
          <div v-for="(item,index) in offers" :key="index">
            <div class="tableBox">
              <div>{{item.name}}</div>
              <div v-if="item.address.length==1"><span v-if="item.address==1">{{$t('joinUs.address1')}}</span><span v-else>{{$t('joinUs.address2')}}</span></div>
              <div v-else-if="item.address.length==2">{{$t('joinUs.address1')}}、{{$t('joinUs.address2')}}</div>
              <div class="operate" @click="showDetails(index)"  @mouseover="addActive(index)" @mouseout="removeActive(index)">{{$t('joinUs.applyNow')}}<span></span></div>
            </div>
             <div class="details" style="display:none">
                  <div class="name">{{item.name}}</div>
                  <div class="address" v-if="item.address.length==1">
                    <div class="adressTip">工作地点：<span v-if="item.address==1">{{$t('joinUs.address1')}}</span><span v-else>{{$t('joinUs.address2')}}</span></div>
                    <div class="money" v-if="indexTab==0"><span v-if="item.moneyKind">薪资范围：{{item.money}}</span><span v-else>薪资范围：{{item.money}}/月</span></div>
                    <div class="money" v-else>薪资范围：{{item.money}}</div>
                  </div>
                  <div v-else-if="item.address.length==2" class="address">
                    <div class="addressTip">工作地点：{{$t('joinUs.address1')}}、{{$t('joinUs.address2')}}</div>
                    <div class="money" v-if="indexTab==0"><span v-if="item.moneyKind">薪资范围：{{item.money}}</span><span v-else>薪资范围：{{item.money}}/月</span></div>
                    <div class="money" v-else>薪资范围：{{item.money}}</div>
                  </div>
                  <div class="position">
                      <div class="position-hd">职位描述：</div>
                      <div class="position-bd" v-for="(items,index) in item.skills" :key="index"><div>{{index+1}}</div>.<div>{{items}}</div></div>
                  </div>
                  <div class="position">
                      <div class="position-hd">任职要求：</div>
                      <div class="position-bd" v-for="(items,index) in item.describe" :key="index"><div>{{index+1}}</div>.<div>{{items}}</div></div>
                  </div>
                  <div class="operate"><a href="Mailto:hr@mindpointeye.com">{{$t('joinUs.apply')}}</a></div>
              </div>
          </div>
        </div>
    </div>
    <div class="footerTip" v-if="indexTab==0">
          <span>备注：</span>
          <div>
          <span>您也可以通过</span>
          <a href="https://company.zhaopin.com/CC457741984.htm">智联招聘</a>、
          <a href="https://www.zhipin.com/gongsi/b82e5426862f25780nJz3tm9Fg~~.html">boss直聘</a>、
          <a href="https://www.lagou.com/gongsi/j118445966.html">拉勾网</a>
          <span>平台进行职位申请</span>
          </div>
    </div>
    <div class="footerTip footerTip2" v-if="indexTab==1||indexTab==2">
          <span>备注：</span>
          <div>
          <span>邮件标题格式按照：姓名+应聘岗位+工作地点</span>
          </div>
    </div>
    <div class="footerTipTwo" v-if="indexTab==0"><span style="opacity:0">备注：</span><div>邮件标题格式按照：姓名+应聘岗位+工作地点</div></div>
  <!--    <div class="selectBoxRight" v-if="isMobile" style="margin-bottom:0.94rem;text-align:center;">-->
  <!--        <img src="../assets/img/joinUs/joinUsHr.png" style="width:6.2rem;height:6.2rem;pointer-events:auto;" />-->
  <!--        <div style="font-size:0.5rem;margin-top:0.5rem">{{$t('joinUs.tip5')}}</div>-->
  <!--    </div>-->
<!--    <Footer></Footer>-->
  </div>
</template>
<script>
  // import Header from '@/components/common/Header'
  import Footer from '@/components/common/newJoinUs/footer'
  import myheader from '@/components/common/newJoinUs/header'
  import {mapGetters} from 'vuex'
  export default {
    name: 'JoinUs',
    components: {
      Footer,
      myheader
    },
    props: {},
    data () {
      return {
        selectOne:0,
        selectTwo:0,
        total:0,
        kind1:0,//地址 0-全部  1-烟台 2-扬州
        kind2:0,//职业种类 0-全部 1-技术 2-生产制造 3-产品 4-设计 5-运营 6-人事 7-销售
        offers:[],//

        indexTab:0,//0-社会招聘  1-校园招聘   2--实习招聘
      }
    },
    methods: {
      // 社会招聘 校园招聘切换
      getOffers(index){
        if(index==0){
          this.offers=this.$store.state.offers;
        }else if(index==1){
          this.offers=this.$store.state.schoolOffers;
        }else if(index==2){
          this.offers=this.$store.state.shixiOffers;
        }
        this.selectOne=0;
        this.selectTwo=0;
        this.indexTab=index;
        console.log(this.offers,index,'当前offser');
         $('body').removeClass('overflowHidden')
      },
      showDetails(index){
          if($('.tableBox .operate').eq(index).hasClass('active')){
            $('.details').hide();
            $('.tableBox .operate').eq(index).removeClass('active');
            $('.tableBox').eq(index).removeClass('click');
          }else{
            $('.tableBox .operate').removeClass('active');
           $('.tableBox .operate').eq(index).addClass('active');
           $('.tableBox').removeClass('active');
           $('.tableBox').removeClass('click');
           $('.tableBox').eq(index).addClass('click');
          $('.details').hide();
          $('.details').eq(index).show();
          }
      },
      addActive(index){
        $('.tableBox').eq(index).addClass('active');
      },
      removeActive(index){
        $('.tableBox').eq(index).removeClass('active')
      },
      goDetail(){
        this.$router.push({path:"/newJoinUs/details"});
      },
      //切换城市
      changeCity(index){
        this.selectOne=index;
        this.kind1=index;
        $('.details').hide();
        $('.tableBox').removeClass('active');
        $('.tableBox').removeClass('click');
        $('.tableBox .operate').removeClass('active');
        this.selectJob();
      },
      // 切换种类
      changeKind(index){
        this.selectTwo=index;
        this.kind2=index;
        $('.details').hide();
        $('.tableBox').removeClass('active');
        $('.tableBox').removeClass('click');
        $('.tableBox .operate').removeClass('active');
        this.selectJob();
      },
      //初始化
      init(){
        // console.log(this.$store.state.offers);

        if(this.indexTab==0){
           this.offers=this.$store.state.offers;
        }else if(this.indexTab==1){
          this.offers=this.$store.state.schoolOffers;
        }else if(this.indexTab==2){
          this.offers=this.$store.state.shixiOffers;
        }
        this.total=this.offers.length;
      },
      //筛选
      selectJob(){
        this.offers=[];
        var allJobs=[];
        if(this.indexTab==0){
          allJobs=this.$store.state.offers
        }else if(this.indexTab==1){
          allJobs=this.$store.state.schoolOffers;
        }else if(this.indexTab==2){
          allJobs=this.$store.state.shixiOffers;
        }
        allJobs.forEach((item)=>{
          if(this.kind1==0){ //地址是否全部---全部
            if(this.kind2==0){
              this.offers.push(item)
            }else{
              if(this.kind2==item.kind1){
                this.offers.push(item);
              }
            }
          }else{
            if(item.address.includes(this.kind1)){
                 if(this.kind2==0){
                    this.offers.push(item)
               }else{
                 if(this.kind2==item.kind1){
                   this.offers.push(item)
                 }
               }
            }
          }
        });
        this.total=this.offers.length;
      }
    },
    mounted () {
      $('html,body').scrollTop(0);

      let params = this.$route.query;
      if(params&&params.intern&&params.intern==2){//实习招聘
          this.indexTab=2;
      }else if(params&&params.campus&&params.campus==1){//校招
        this.indexTab=1;
      }
      this.init();
    },
    beforeDestroy () {
    },
    computed: {
      ...mapGetters(['isMobile', 'lang']),
      getComponentName () {
        return 'JoinUs'
      }
    }

  }
</script>

<style lang="scss" scoped>
    .selectBox{
        width:85%;
        overflow: hidden;
        margin:5.25rem auto 0;
        box-sizing: border-box;
        display: flex;
        box-sizing: border-box;
        .selectBoxLeft{
          flex: 1;
          margin-top: 1.25rem;
          box-sizing: border-box;
          padding-left:6.13rem;
          background: #fff;
          &>div{
            // display:flex;
            overflow: hidden;
            &:first-child{
              margin-top:1.87rem;
              span{
                &:hover{
                  color: #3292FF;
                }
              }
            }
            &:nth-child(2){
                span{
                &:hover{
                  color: #3292FF;
                }
              }
            }

            margin-bottom: 1.5rem;
            &>div:nth-child(1){
              // min-width: 5rem;
              margin-right: 2.5rem;
              font-size: 1rem;
              color: #333;
              float: left;
            }
            &>div:nth-child(2){
              span{
              margin-right: 2.5rem;
              font-size: 1rem;
              color: #333;
              cursor: pointer;
              &.active{
                color: #3292FF;
              }
            }
            span:last-child{
              margin-right: 0;
            }
          }
          }
        }
        .selectBoxRight{
          float: right;
          text-align: center;
          background: #fff;
          margin-top:1.25rem;
          padding-right: 3rem;
          padding-top: 1.87rem;
          padding-bottom: 1.87rem;
          box-sizing: border-box;
          div{
            font-size: 1rem;
            color: #333;
            font-weight: 400;
          }
        }
    }
  .job-offer {
    width: 85%;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 6.25rem;
    // max-width: 75rem;
    box-sizing: border-box;
    padding: 0 3.13rem;
    background: #fff;
    margin: 0 auto;
    position: relative;
    // margin-bottom: 1.83rem;
    ul{
        margin: 0;
        padding: 0;
        list-style: none;
        width: 100%;
        height: 3.75rem;
        background: linear-gradient(90deg, rgba(59, 73, 98, 1) 0%, rgba(29, 38, 50, 1) 100%);
        font-size: 1rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height:3.75rem;
        display: flex;
        li{
            font-size: 1rem;
            color: #F7F8FA;
            margin: 0;
            padding: 0;
            list-style: none;
            flex: 1;
            &:nth-child(1){
                max-width: 55%;
                box-sizing: border-box;
                padding-left:3rem;
                padding-right: 3rem;
            }
            &:nth-child(2){
                max-width:25%;
            }
            &:nth-child(3){
                max-width:20%;
            }
        }
    }
    .table-ui {
      width: 100%;
      text-align: left;
      background: #fff;
      &>div{
          width: 100%;
          &>div.tableBox{
            &.active{
              .operate{
                color: #2B9EFF;
                span{
                  //background: url("../assets/img/joinUs/joinBtn2.png") no-repeat;
                  background-size: contain;
                }
              }
            }
            &.click{
               .operate{
                span{
                  //background: url("../assets/img/joinUs/joinBtn1.png") no-repeat;
                  background-size: contain;
                }
              }
            }
              display: flex;
              font-size: 1rem;
              padding: 1.38rem 0;
              font-weight:400;
              color:#333;
              border-bottom: 1px solid #eee;
              &>div:nth-child(1){
                    max-width: 55%;
                    padding-left:3rem;
                    padding-right: 3rem;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    flex: 1;
                }
                &>div:nth-child(2){
                    max-width:25%;
                    display: flex;
                    align-items: center;
                    flex: 1;
                }
                &>div:nth-child(3){
                    max-width:20%;
                    display: flex;
                    align-items: center;
                    flex: 1;
                    a{
                      color: #333;
                      text-decoration: none;
                      &:hover{
                        color: #3292FF;
                        text-decoration: none;
                      }
                    }

                }
              .operate {
                cursor: pointer;
                span{
                  //background: url("../assets/img/joinUs/joinBtn3.png") no-repeat;
                  background-size: 0.69rem 0.5rem;
                  display: inline-block;
                  width: 1.69rem;
                  height: 0.5rem;
                  margin-left: 0.25rem;
                }
                &.active{
                    color: #2B9EFF;
                }
              }
              // .operate:hover {
              //   color: #2B9EFF;
              // }
        }
        &>.details{
            width:100%;
            background: #fff;
            box-sizing: border-box;
            padding-left:3rem;
            margin: 1.88rem auto 0;
            padding-bottom: 3rem;
            border-bottom: 1px solid #eee;
            .name{
                font-size:1.88rem;
                font-weight:400;
                color:rgba(51,51,51,1);
                letter-spacing:1px;
                margin-bottom: 1.87rem;
            }
            .address{
                font-size:1rem;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:1rem;
                letter-spacing:1px;
                margin-bottom: 1.87rem;
                display: flex;
                &>div{
                  &:nth-child(1){
                    margin-right: 3rem;
                  }
                }
            }
            .position{
                margin-bottom: 1.25rem;
                .position-hd{
                    font-size:1rem;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:1rem;
                    letter-spacing:1px;
                    margin-bottom: 1.25rem;
                }
                .position-bd{
                    font-size:0.88rem;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height:1.88rem;
                    display: flex;
                    &>div{

                    }
                }
            }
            .operate{
                width: 100%;
                position: relative;
                margin-top:3.13rem;
                text-align: center;
                a{
                    display: inline-block;
                    width:7.5rem;
                    height:2.5rem;
                    text-align: center;
                    line-height: 2.5rem;
                    background:rgba(50,146,255,1);
                    color: #fff;
                    font-size: 1rem;
                    font-weight: 400;
                    text-decoration: none;
                }
            }
        }
      }
    }
  }

  .footerTip{
    width: 85%;
    height: auto;
    // display: flex;
    padding: 0 3.13rem;
    margin: 0 auto;
    position: relative;
    margin-bottom:0.5rem;
    padding-left:6rem;
    margin-top: 1.38rem;
    font-size: 1rem;
    overflow: hidden;
    // display: flex;
    a{
      font-size: 1rem;
      text-decoration: none;
      color: #3292FF;
      // display: inline-block;

    }
    &>span{
      font-size: 1rem;
      float: left;
    }
    &>div{
      float: left;
    }
  }
  .footerTip2{
    margin-bottom: 1.38rem;
  }
  .footerTipTwo{
    width: 85%;
    height: auto;
    // display: flex;
    padding: 0 3.13rem;
    margin: 0 auto;
    position: relative;
    margin-bottom: 1.38rem;
    padding-left:6rem;
    // margin-top: 1.38rem;
    font-size: 1rem;
    overflow: hidden;
     &>span{
      font-size: 1rem;
      float: left;
    }
    &>div{
      float: left;
    }
  }

  // 移动端
  .join-us-vs{
    .footerTip{
    width: 100%;
    height: auto;
    display: flex;
    padding: 0 0.95rem;
    margin: 0 auto;
    position: relative;
    margin-bottom:0.4rem;
    margin-top:0.98rem;
    font-size: 0.5rem;
    a{
      font-size: 0.5rem;
    }
    &>span{
      font-size: 0.5rem;
      // float: left;
      min-width: 2rem;
    }
    &>div{
      // float: left;
    }
  }
   .footerTip2{
    margin-bottom:0.98rem;
  }
    .footerTipTwo{
    width:100%;
    height: auto;
    // display: flex;
    // padding: 0 3.13rem;
    // margin: 0 auto;
    position: relative;
    margin-bottom:0.95rem;
    padding: 0;
    padding-left:0.95rem;
    margin-top: 0rem;
    display: flex;
    font-size:0.5rem;
    &>span{
       min-width: 2rem;
       font-size: 0.5rem;
    }

  }
     .selectBox{
        width:100%;
        overflow: hidden;
        margin:3.5rem auto 0;
        box-sizing: border-box;
        display: flex;
        box-sizing: border-box;
        .selectBoxLeft{
          flex: 1;
          box-sizing: border-box;
          padding-left:0rem;
          background: #fff;
          padding-left: 0.95rem;
          padding-top:0.95rem;
          padding-bottom:0.3rem;
          padding-left: 0.95rem;
          margin-top:0rem;
          padding-right: 0.95rem;
          &>div{
            &:first-child{
             margin-top:0rem;
             margin-bottom: 0rem;
             &>div{
               span{
                 margin-bottom: 0;
               }
             }
            }
            // line-height:2rem;
            margin-bottom:0rem;
            // display:flex;
            // align-items: initial;
            overflow: hidden;
            &>div:nth-child(1){
              font-size:0.5rem;
              color: #333;
              // min-width:2rem;
              margin-right:0.5rem;
              // background: red;
              float: left;
              // background: red;
            }
            &>div:nth-child(2){
              overflow: hidden;
              // float: left;
              // background: green;
              span{
              margin-right:0.8rem;
              font-size:0.5rem;
              color: #333;
              float: left;
              margin-bottom: 0.63rem;
              // display: inline-block;
              cursor: pointer;
              &.active{
                color: #3292FF;
              }
            }
            span:last-child{
              margin-right: 0;
            }
          }
        }
        }
        .selectBoxRight{
          float: right;
          text-align: center;
          background: #fff;
          margin-top:0rem;
          padding-right:0rem;
          padding-top: 1.87rem;
          padding-bottom: 1.87rem;
          box-sizing: border-box;
          div{
            font-size:0.88rem;
            color: #333;
            font-weight: 400;
          }
        }
    }
    .job-offer {
      width:100%;
      height: auto;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: 0;
      background: #fff;
    ul{
        margin: 0;
        padding: 0;
        list-style: none;
        width: 100%;
        height:1.88rem;
        background: linear-gradient(90deg, rgba(59, 73, 98, 1) 0%, rgba(29, 38, 50, 1) 100%);
        font-size:0.5rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height:1.88rem;
        display: flex;
        box-sizing:border-box;
        padding: 0 0.95rem;
        li{
            font-size: 0.5rem;
            color: #F7F8FA;
            margin: 0;
            padding: 0;
            list-style: none;
            flex: 1;
            // text-align: center;
            &:nth-child(1){
                max-width: 50%;
                box-sizing: border-box;
                // padding-left:0.5rem;
                // padding-right: 0.5rem;
            }
            &:nth-child(2){
                max-width:30%;
            }
            &:nth-child(3){
                max-width:20%;
            }
        }
    }
    }
    .table-ui {
      width: 100%;
      text-align: left;
      background: #fff;
      &>div{
          width: 100%;
          // display: flex;

          padding: 0 0.95rem;
        &>div.tableBox{
          // flex: 1;
          display: flex;
          font-size: 0.5rem;
          padding:0.69rem 0;
          font-weight:400;
          color:#333;
          border-bottom: 1px solid #eee;
          &>div:nth-child(1){
                max-width: 50%;
                 padding-left:0rem;
                 padding-right: 0rem;
                 box-sizing: border-box;
                display: flex;
                align-items: center;
            }
            &>div:nth-child(2){
                max-width:30%;
                display: flex;
                align-items: center;
                // justify-content: center;
            }
            &>div:nth-child(3){
                max-width:20%;
                display: flex;
                align-items: center;
                // justify-content: center;
                cursor: pointer;
                a{
                  color: #333;
                  text-decoration: none;
                  &:hover{
                    // color: #3292FF;
                    text-decoration: none;
                  }
                }

            }
          .operate {
            cursor: pointer;
            span{
                  //background: url("../assets/img/joinUs/joinBtn3.png") no-repeat;
                  background-size: 0.3rem 0.25rem;
                  display: inline-block;
                  width:0.8rem;
                  height: 0.25rem;
                  margin-left: 0.2rem;
              }
          }
          // .operate:hover {
          //   color: #3292FF;
          // }
        }
        &>div.details{
          width:100%;
          background: #fff;
          box-sizing: border-box;
          padding:0.94rem 0 1.56rem;
          margin: 0;
          .name{
              font-size:0.94rem;
              font-weight:400;
              color:rgba(51,51,51,1);
              letter-spacing:1px;
              margin-bottom:0.94rem;
          }
          .address{
              font-size:0.5rem;
              font-weight:400;
              color:rgba(51,51,51,1);
              line-height:0.5rem;
              letter-spacing:1px;
              margin-bottom:0.94rem;
              &>div{
                display: flex;
                &:nth-child(1){
                  margin-right: 1.5rem;
                }
              }
          }
          .position{
              margin-bottom:0.63;
              .position-hd{
                  font-size:0.5rem;
                  font-weight:400;
                  color:rgba(51,51,51,1);
                  line-height:1rem;
                  letter-spacing:1px;
                  margin-bottom:0.63rem;
              }
              .position-bd{
                  font-size:0.5rem;
                  font-weight:400;
                  color:rgba(102,102,102,1);
                  line-height:1.4rem;
              }
          }
          .operate{
              width: 100%;
              position: relative;
              margin-top:1.25rem;
              text-align: center;
              a{
                  display: inline-block;
                  width:3.75rem;
                  height:1.25rem;
                  text-align: center;
                  line-height:1.25rem;
                  background:rgba(50,146,255,1);
                  color: #fff;
                  font-size:0.5rem;
                  font-weight: 400;
                  text-decoration: none;
              }
          }
        }
      }
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/newJoinUs.vue